import { create } from "zustand";
import { startRouteTracking, endRouteTracking, initUnloadTracking } from "@services/route-tracking";

const getInitialView = () => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    // Keep in sync with MinSkog.js `viewOptions` (deep links / profile_edit redirect).
    const viewOptions = [
        'karta',
        'overblick',
        'annonser',
        'pricing',
        'virkespriser',
        'settings',
        'marknadsinformation',
        'sell-timber',
    ];

    if (urlSearchParams.get('view') && viewOptions.includes(urlSearchParams.get('view'))) {
        const comp = urlSearchParams.get('view');
        const sellAd = urlSearchParams.get('sell-timber-ad');
        if (comp === 'sell-timber' && sellAd) {
            const id = parseInt(sellAd, 10);
            return {
                comp: 'sell-timber',
                sellTimberAdId: Number.isNaN(id) ? undefined : id
            };
        }
        if (comp === 'settings') {
            const settingsTab = urlSearchParams.get('settings_tab');
            if (settingsTab) {
                return { comp: 'settings', settingsTab };
            }
        }
        return { comp };
    }

    if (history.state && history.state != null) {
        return history.state;
    }

    return { comp: 'overblick' };
}

const initialView = getInitialView();
startRouteTracking(initialView.comp);
initUnloadTracking();

export const useNavigationStore = create((set) => ({
  view: initialView,
  setView: (newView) => {
    endRouteTracking();
    startRouteTracking(newView.comp);
    set({ view: newView });
  },
}));

/**
 * SPA navigation inside Min Skog: updates the URL query (for refresh/share) and history.state
 * so Back/Forward match setView. Pass { settingsTab: 'my-ads' } with comp "settings" for Inställningar tabs.
 */
export function pushMinSkogView(compName, extra = {}) {
  const setView = useNavigationStore.getState().setView;
  const newView = { comp: compName, ...extra };
  const url = new URL(window.location.href);
  url.searchParams.set('view', compName);
  if (extra.settingsTab) {
    url.searchParams.set('settings_tab', extra.settingsTab);
  } else {
    url.searchParams.delete('settings_tab');
  }
  window.history.pushState(newView, '', url);
  setView(newView);
}
